<div class="flex items-center justify-center min-h-screen bg-white">
    <div class="flex flex-col items-center">
        <div class="relative w-full flex justify-center my-6">
            <img
                src="/assets/images/shared/left-arrow-icon.png"
                alt="Back"
                class="h-5 w-auto absolute left-4 top-1/2 -translate-y-1/2 cursor-pointer"
                [routerLink]="['/login']"
                [queryParams]="{ email }" />

            <img src="/assets/images/auth/interseed-new-logo.png" alt="interseed logo" class="h-16 w-auto" />
        </div>

        <div class="text-center mt-6">
            <p class="text-[#0A0A0A] text-xl font-semibold">Forgot password?</p>
            <p class="text-[#717182] text-sm mt-2">Enter your email to reset</p>
        </div>

        <div
            class="w-full max-w-[600px] sm:min-w-[544px] rounded-[20px] border border-[#E2E8F0] bg-white/90 my-6 p-8 shadow-xl backdrop-blur">
            <form [formGroup]="resetPasswordForm" (ngSubmit)="submit()">
                <div class="flex flex-col space-y-2">
                    <label for="email" class="text-xs text-[#0A0A0A] font-semibold uppercase">Email Address</label>
                    <input
                        type="email"
                        id="email"
                        formControlName="email"
                        placeholder="Your@email.com"
                        class="w-full form-field-container" />
                    @if (resetPasswordForm.get('email')?.touched && resetPasswordForm.get('email')?.errors) {
                        @if (resetPasswordForm.get('email')?.errors?.['required']) {
                            <div class="text-red-500 text-[0.625rem]">Email Address is required.</div>
                        } @else if (resetPasswordForm.get('email')?.errors?.['pattern']) {
                            <div class="text-red-500 text-[0.625rem]">Please enter a valid email.</div>
                        }
                    }
                </div>

                <button type="submit" class="w-full border-button mt-4" [disabled]="resetPasswordForm.invalid">
                    Send Reset Link
                </button>
            </form>
        </div>
    </div>
</div>
